import { render, staticRenderFns } from "./RedirectToIntegration.vue?vue&type=template&id=334525b4"
import script from "./RedirectToIntegration.vue?vue&type=script&lang=ts"
export * from "./RedirectToIntegration.vue?vue&type=script&lang=ts"
import style0 from "./RedirectToIntegration.vue?vue&type=style&index=0&id=334525b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports